<template>
  <path pid="0" d="M19.21 6.79l-5.5-5.5A1 1 0 0012 2v8.59l-3.79-3.8a1 1 0 10-1.42 1.42l4.8 4.79-4.8 4.79a1 1 0 101.42 1.42l3.79-3.8V24a1 1 0 001.71.71l5.5-5.5a1 1 0 000-1.42L14.41 13l4.8-4.79a1 1 0 000-1.42zM17.09 18.5L14 21.59v-6.18zM14 10.59V4.41l3.09 3.09z"/>
</template>
